import Invoice from 'model/Invoice'

import globalFnFactory from 'components/globalFn/globalFnFactory'
import modalInvoiceInfo from '../../reimburseManage/reimbursement/view/modalInvoiceInfo.html'
import {parseOfdDocument, renderOfd} from "../../../../../vendor/ofd/ofd";

const globalFn = globalFnFactory()
class modalListCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, $uibModal, hasPDFReader) {
        let allInvoiceList = items1.modalListData
        const { currentInvoicId } = items1
        const { fromWhere } = items1 // 用于标识来源 1. 发票收集 2. 发票管理 暂时没用，因为传了param
        let pageNum = items1.originalPageNum - 1
        let { originalPageNum } = items1
        const { pageSize } = items1
        let { total } = items1
        const { param } = items1
        $scope.currentIndex = pageNum * pageSize
        httpRequest.get_dictByTypeArr(['ovat_tax_rate']).then((res) => {
            $scope.ivatTaxRate = res.data.value.ovat_tax_rate
        })
        $scope.init = function (paramId) {
            httpRequest.get_selectBillDetailById(paramId).then((res) => {
                $scope.reimburseDeitalFrom = res.data.value
                $scope.invoiceType = $scope.reimburseDeitalFrom.invoiceType
                const storageKey = $scope.reimburseDeitalFrom.fileInfo?$scope.reimburseDeitalFrom.fileInfo.storageKey:''
                const fileType = storageKey.substring(storageKey.length - 3, storageKey.length).toLowerCase()
                $scope.ispdf = false // 票据影像类型
                $scope.isofd = false // 票据影像类型OFD
                $scope.noimg = false // 无票据影像类型
                $scope.isNormalInvoice = ($scope.invoiceType == '0' || $scope.invoiceType == '2' || $scope.invoiceType == '51' || $scope.invoiceType == '12' || $scope.invoiceType == '14' || $scope.invoiceType == '41' || $scope.invoiceType == '15' || $scope.invoiceType == '52')
                for (let i = 0; i < allInvoiceList.length; i++) {
                    if ((allInvoiceList[i].invoiceId || allInvoiceList[i]) == paramId) {
                        $scope.currentIndex = pageNum * pageSize + i
                        break
                    }
                }
                $scope.showPreTask = $scope.currentIndex != 0
                // $scope.showNextTask = $scope.currentIndex == (allInvoiceList.length - 1) ? false : true
                $scope.showNextTask = $scope.currentIndex !== total - 1
                // 截取验证码 切换图片
                if ($scope.reimburseDeitalFrom.checkCode) {
                    $scope.reimburseDeitalFrom.checkCode = $scope.reimburseDeitalFrom.checkCode.substring($scope.reimburseDeitalFrom.checkCode.length - 6)
                }
                if ($scope.reimburseDeitalFrom.fileInfo && fileType == 'pdf') {
                    $scope.ispdf = true
                    if (hasPDFReader()) $scope.canShowPDF = true
                }
                if ($scope.reimburseDeitalFrom.fileInfo && fileType == 'ofd') {
                    $scope.isofd = true
                    let file = null
                    const fileUrl = `${host.etcloudIvatApp}common/common/getFile?fileKey=${$scope.reimburseDeitalFrom.fileInfo.storageKey}`
                    $scope.getFileFromUrl(fileUrl,$scope.reimburseDeitalFrom.fileInfo.fileName)
                        .then((response)=>{
                            file = response
                            $scope.getOfdDocumentObj(response, document.body.clientWidth);
                        })
                        .catch((e)=>{
                            console.error(e)
                        });

                }
                const imagKey = $scope.reimburseDeitalFrom.fileInfo ? $scope.reimburseDeitalFrom.fileInfo.storageKey : ''
                if ($scope.reimburseDeitalFrom.fileInfo) {
                    $scope.imgSrc = `${host.etcloudIvatApp}common/common/getFile?fileKey=${imagKey}`
                } else {
                    $scope.noimg = true
                    $scope.imgSrc = ''
                    if ($scope.reimburseDeitalFrom.verifyStatus == 1) {
                        httpRequest.get_getInvoice({
                            invoiceCode: $scope.reimburseDeitalFrom.invoiceCode,
                            invoiceNumber: $scope.reimburseDeitalFrom.invoiceNumber,
                        }).then((res) => {
                            $scope.invoice = new Invoice(res.data.value)
                            $scope.invoice.invType = $scope.invoice.invoiceType
                            $scope.invoice.chineseAmtTotal = globalFn.digitUppercase($scope.invoice.adValoremTotal)
                            if (res.data.value.invoiceType == '41' || res.data.value.invoiceType == '12' ) $scope.codeVersions = $scope.invoice.details[0].revenueVersion
                        })
                    }
                }
            })
        }
        $scope.init(currentInvoicId)
        //url转为files文件流
        $scope.getFileFromUrl = function (url, fileName){
            return new Promise((resolve, reject) => {
                var blob = null;
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url);
                xhr.setRequestHeader('Accept', 'application/ofd');
                xhr.responseType = "blob";
                // 加载时处理
                xhr.onload = () => {
                    // 获取返回结果
                    blob = xhr.response;
                    let file= new File([blob], fileName, { type: 'application/ofd' });
                    // 返回结果
                    resolve(file);
                };
                xhr.onerror = (e) => {
                    reject(e)
                };
                // 发送
                xhr.send();
            });
        }
        //调用ofdJS绘制 文件格式为OFD的发票
        $scope.getOfdDocumentObj = function (file, screenWidth){
            parseOfdDocument({
                ofd: file,
                success(res) {
                    const divs = renderOfd(screenWidth, res[0]);
                    $scope.displayOfdDiv(divs);
                },
                fail(error) {
                    console.log(error)
                }
            });
        }
        $scope.displayOfdDiv = function (divs) {
            let contentDiv = document.getElementById('content');
            contentDiv.innerHTML = '';
            for (const div of divs) {
                contentDiv.appendChild(div)
            }
        }
        $scope.$watch('currentIndex', (newValue) => { // 控制页码显示
            if (newValue < 1) {
                $scope.showPreTask = false
            } else {
                $scope.showPreTask = true
            }
            // if (newValue >= (allInvoiceList.length - 1)) {
            if (newValue >= total) {
                $scope.showNextTask = false
            } else {
                $scope.showNextTask = true
            }
        })

        $scope.changeTask = function (changeFlag) // -1上一条 1下一条
        {
            // if (($scope.currentIndex <= 0 && changeFlag == -1) || ($scope.currentIndex >= (allInvoiceList.length - 1)) && changeFlag == 1) {
            if (($scope.currentIndex <= 0 && changeFlag == -1) || ($scope.currentIndex >= (total - 1)) && changeFlag == 1) {
                return
            }
            if (changeFlag == 1) {
                $scope.currentIndex += 1
            } else if (changeFlag == -1) {
                (
                    $scope.currentIndex -= 1
                )
            }
            if ($scope.currentIndex - pageNum * pageSize < pageSize && $scope.currentIndex - pageNum * pageSize >= 0) {
                const index = allInvoiceList[$scope.currentIndex - pageNum * pageSize] && allInvoiceList[$scope.currentIndex - pageNum * pageSize].invoiceId ? allInvoiceList[$scope.currentIndex - pageNum * pageSize].invoiceId
                    : allInvoiceList[$scope.currentIndex - pageNum * pageSize]
                $scope.init(index)
            } else if ($scope.currentIndex - pageNum * pageSize >= pageSize && $scope.currentIndex < total) {
                httpRequest.post_selectPageBill({
                    pageSize,
                    pageNum: ++originalPageNum,
                    param,
                }).then((res) => {
                    total = res && res.data && res.data.value && res.data.value.total
                    allInvoiceList = res && res.data && res.data.value && res.data.value.list && res.data.value.list.map((item) => item.invoiceId)
                    pageNum++
                    const index = allInvoiceList[$scope.currentIndex - pageNum * pageSize] && allInvoiceList[$scope.currentIndex - pageNum * pageSize].invoiceId ? allInvoiceList[$scope.currentIndex - pageNum * pageSize].invoiceId
                        : allInvoiceList[$scope.currentIndex - pageNum * pageSize]
                    $scope.init(index)
                })
            } else if ($scope.currentIndex - pageNum * pageSize < 0 && pageNum >= 1) {
                httpRequest.post_selectPageBill({
                    pageSize,
                    pageNum: --originalPageNum,
                    param,
                }).then((res) => {
                    allInvoiceList = res && res.data && res.data.value && res.data.value.list && res.data.value.list.map((item) => item.invoiceId)
                    pageNum--
                    const index = allInvoiceList[$scope.currentIndex - pageNum * pageSize] && allInvoiceList[$scope.currentIndex - pageNum * pageSize].invoiceId ? allInvoiceList[$scope.currentIndex - pageNum * pageSize].invoiceId
                        : allInvoiceList[$scope.currentIndex - pageNum * pageSize]
                    $scope.init(index)
                })
            } else if ($scope.currentIndex - pageNum * pageSize < 0 && pageNum <= 0) {
                $scope.showPreTask = false
            } else {
                $scope.showNextTask = false
            }
        }

        $scope.cancel = () => {
            $uibModalInstance.close()
        }
        $scope.ok = () => {
            $uibModalInstance.close()
        }
        $scope.checkSuccess = function (item) {
            $('iframe').hide()
            $uibModal.open({
                template: modalInvoiceInfo,
                openedClass: 'mod-modal mod-invoice-info',
                animation: true,
                controller: 'modalInvoiceInfo',
                resolve: {
                    invoice() {
                        return {
                            invoiceCode: item.invoiceCode,
                            invoiceNumber: item.invoiceNumber,
                        }
                    },
                },
            }).result.then().finally(() => {
                $('iframe').show()
            })
        }
    }
}

modalListCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', '$uibModal', 'hasPDFReader']
export default modalListCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/collection/collectionModalListCtrl.js